/**
 * @generated SignedSource<<cf1e324a8a927b2085a99e2d6685e55b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useEnablePushNotificationsQuery$variables = {};
export type useEnablePushNotificationsQuery$data = {
  readonly notificationSubscriptions: {
    readonly surveyInviteContactChannels: ReadonlyArray<string> | null;
  };
};
export type useEnablePushNotificationsQuery = {
  response: useEnablePushNotificationsQuery$data;
  variables: useEnablePushNotificationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "surveyInviteContactChannels",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useEnablePushNotificationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationSubscriptions",
        "kind": "LinkedField",
        "name": "notificationSubscriptions",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useEnablePushNotificationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationSubscriptions",
        "kind": "LinkedField",
        "name": "notificationSubscriptions",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b96e6b7a7d5a7c21db66c2f72d8dbce9",
    "id": null,
    "metadata": {},
    "name": "useEnablePushNotificationsQuery",
    "operationKind": "query",
    "text": "query useEnablePushNotificationsQuery {\n  notificationSubscriptions {\n    surveyInviteContactChannels\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c26d31da1a775c7bab04f0783bf9a979";

export default node;
